<template>
  <div
    :contenteditable="allowEditing"
    v-once
    v-html="value"
    :value="value"
    @input="$emit('input', $event.target.innerHTML)"
    class="w-full my-5"
  ></div>
</template>

<script>
export default {
  name: "Editable",
  components: {},
  props: {
    allowEditing: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    }
  },
  watch: {
    value: function(newValue) {
      if (document.activeElement == this.$el) {
        return;
      }

      this.$el.innerHTML = newValue;
    },
    allowEditing: function() {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    }
  }
};
</script>

<style></style>
